import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useVideoControl } from "../hooks";
import ReactPlayer from "react-player";
import { VideoControl } from "./VideoControl";
import { showFailureToast } from "@helpers";
import styles from "./styles/VideoPlayer.module.css";

const VideoPlayer = (props) => {
  const { data, hasNext, handleNext } = props;
  // state

  // logics before hooks

  // hooks
  const {
    state,
    playerRef,
    playerContainerRef,
    handlePlayPause,
    handleRewind,
    handleFastForward,
    handleMuted,
    handleVolumeChange,
    handlePlaybackRateChange,
    toggleFullScreen,
    handleProgress,
    handleChangeSeek,
    handleSeekMouseDown,
    handleSeekMouseUp,
    // clearPlayer,
    handleEnd,
    handleClickNext,
  } = useVideoControl(data, hasNext, handleNext);

  // logics

  // UI partials

  // effects

  //   videoUrl
  // variables
  const { playing, muted, volume, playbackRate } = state;
  const videoUrl = data?.videoUrl || data?.videoExternalUrl;

  // render
  return (
    <div ref={playerContainerRef} className={clsx(styles.video)}>
      <ReactPlayer
        ref={playerRef}
        url={videoUrl}
        onProgress={handleProgress}
        width="100%"
        height="100%"
        controls={false}
        playing={playing}
        muted={muted}
        volume={volume}
        playbackRate={+playbackRate}
        pip={false}
        loop={false}
        onEnded={handleEnd}
        onError={() => {
          showFailureToast("Can not play video");
        }}
      />
      <VideoControl
        state={state}
        totalTimes={playerRef.current?.getDuration() || 0}
        onPlayPause={handlePlayPause}
        onRewind={handleRewind}
        onFastForward={handleFastForward}
        onMuted={handleMuted}
        onChangeVolume={handleVolumeChange}
        onChangePlaybackRate={handlePlaybackRateChange}
        onToggleFullScreen={toggleFullScreen}
        onSeek={handleChangeSeek}
        onSeekMouseDown={handleSeekMouseDown}
        onSeekMouseUp={handleSeekMouseUp}
        onNext={handleClickNext}
      />
    </div>
  );
};

/* required: display name */
VideoPlayer.displayName = "VideoPlayer";

/* required: props types */
VideoPlayer.propTypes = { data: PropTypes.object };

/* required: default props */
VideoPlayer.defaultProps = {};

export { VideoPlayer };
